export enum PaymentWaiverReasonEnum {
  claimsSubmittedIncorrectly = 'claims_submitted_incorrectly_to_clearinghouse',
  clientOnPaymentPlan = 'client_on_payment_plan',
  claimChangedFromSelfPayToInsurance = 'claim_changed_from_self_pay_to_insurance',
  claimsIncorrectlyProcessingAsOon = 'claims_incorrectly_processing_as_oon',
  providerAgreedToWaiveFee = 'provider_agreed_to_waive_fee',
  clientInitiatedDueToProviderNoShow = 'client_initiated_due_to_provider_no_show',
  providerAccidentallyChargedLateFee = 'provider_accidentally_charged_late_fee',
  refundedToClientWithoutProviderAgreement = 'refunded_to_client_without_provider_agreement'
}

export const getPaymentWaiverReasonString = (reason: PaymentWaiverReasonEnum) => {
  switch (reason) {
    case PaymentWaiverReasonEnum.claimsSubmittedIncorrectly:
      return 'Claims were submitted incorrectly to the clearinghouse';
    case PaymentWaiverReasonEnum.clientOnPaymentPlan:
      return 'Client is on a payment plan';
    case PaymentWaiverReasonEnum.claimChangedFromSelfPayToInsurance:
      return 'Claim changed from self-pay to insurance';
    case PaymentWaiverReasonEnum.claimsIncorrectlyProcessingAsOon:
      return 'Claims are incorrectly processing as out-of-network';
    case PaymentWaiverReasonEnum.providerAgreedToWaiveFee:
      return 'Provider agreed to waive the fee';
    case PaymentWaiverReasonEnum.clientInitiatedDueToProviderNoShow:
      return 'Client initiated due to provider no-show';
    case PaymentWaiverReasonEnum.providerAccidentallyChargedLateFee:
      return 'Provider accidentally charged a late fee';
    case PaymentWaiverReasonEnum.refundedToClientWithoutProviderAgreement:
      return 'Refunded to client without provider agreement';
    default:
      return 'Unknown reason';
  }
};
